const currencies = { RUB: '₽', EUR: '€', GBP: '£', USD: '$' };

export const getCurrencyChar = currency => currencies[currency];
